export const GET_SUBSCRIBERS = "GET_SUBSCRIBERS";
export const GET_SUBSCRIBERS_SUCCESS = "GET_SUBSCRIBERS_SUCCESS";
export const GET_SUBSCRIBERS_FAILURE = "GET_SUBSCRIBERS_FAILURE";

export const DELETE_SUBSCRIBERS = "DELETE_SUBSCRIBERS";
export const DELETE_SUBSCRIBERS_SUCCESS = "DELETE_SUBSCRIBERS_SUCCESS";
export const DELETE_SUBSCRIBERS_FAILURE = "DELETE_SUBSCRIBERS_FAILURE";
